/**
 * Server-backed library persistence adapter.
 * Stores library items per-user on the server (SQLite) instead of browser IndexedDB.
 * Deduplication is handled server-side.
 */

import type { LibraryPersistenceAdapter } from "@excalidraw/excalidraw/data/library";
import type { LibraryItems } from "@excalidraw/excalidraw/types";

export const ServerLibraryAdapter: LibraryPersistenceAdapter = {
  async load(_metadata: {
    source: "load" | "save";
  }): Promise<{ libraryItems: LibraryItems } | null> {
    try {
      const res = await fetch("/api/user-libraries", {
        credentials: "include",
      });
      if (!res.ok) {
        return null;
      }
      const data = await res.json();
      return { libraryItems: data.libraryItems || [] };
    } catch (err) {
      console.error("Failed to load libraries from server:", err);
      return null;
    }
  },

  async save(libraryData: { libraryItems: LibraryItems }): Promise<void> {
    try {
      await fetch("/api/user-libraries", {
        method: "PUT",
        credentials: "include",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ libraryItems: libraryData.libraryItems }),
      });
    } catch (err) {
      console.error("Failed to save libraries to server:", err);
    }
  },
};
